import { Component } from '@angular/core';
import BaseComponent from '../BaseComponent';
import { GoogleIntegrationService } from '../../../services/google-integration.service';
import Utils from '../../../shared/utils';

@Component({
  selector: 'app-components-ticket-seo-starter-onboarding-link',
  templateUrl: './seo-starter-onboarding-link.component.html'
})
export class SeoStarterOnboardingLinkComponent extends BaseComponent {
  public onboardingUrl = '';

  constructor(private googleIntegrationService: GoogleIntegrationService) {
    super();
  }

  public activate(params: app.ticket.components.interfaces.ITicketComponentActivateParams): JQueryPromise<void> {
    return super.activate(params)
      .then(() => this.loadOnboardingUrl());
  }

  private loadOnboardingUrl(): JQueryPromise<void> {
    return Utils.wrapDfd(this.googleIntegrationService.getOnboardingUrl(this.customer.CustomerId()))
      .then((url: string) => {
        this.onboardingUrl = url;
      });
  }
}
